import Decimal from 'decimal.js-light';
import formatNumber from 'format-number-with-string';

const NUMBER_FORMAT = '## ##0';

/**
 * Returns the value divided by 100 and then by 12.
 * Useful to convert decimals into monthly rate percentages.
 * Accept strings and numbers.
 *
 * @param value string|number
 * @returns {number}
 */
export const toMonthlyPercent = (value) => {
  return (new Decimal(value)).dividedBy(100).dividedBy(12).toNumber();
};

/**
 * Round a value.
 * Convert value as Decimal object before to apply rounding.
 * XXX Necessary to fix the JS math operation flaws with floats numbers.
 *
 * @param value
 * @param precision
 * @returns {Number}
 */
export const round = (value, precision = 2) => {
  try {
    // Convert back string to number.
    return parseFloat(
      (
        // Convert to Decimal in order to correctly round the result.
        new Decimal(value)
      ).toFixed(precision) // Round the result, 2 decimals max XXX this returns a string
      , 10);
  } catch (e) {
    console.error('round', e);
  }
};

export const format = (number) => {
  return formatNumber(number, NUMBER_FORMAT);
};


// WEBPACK FOOTER //
// ./src/math.js